import { render, staticRenderFns } from "./ProductGalleryCarousel.vue?vue&type=template&id=3c921d2e&scoped=true"
import script from "./ProductGalleryCarousel.vue?vue&type=script&lang=js"
export * from "./ProductGalleryCarousel.vue?vue&type=script&lang=js"
import style0 from "./ProductGalleryCarousel.vue?vue&type=style&index=0&id=3c921d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c921d2e",
  null
  
)

export default component.exports